import { generateUUID } from ".";

export const getTokenCookie = () => {
  let allcookies = document.cookie.split(';');
  let token = false;
  for (let i = 0; i < allcookies.length; i++) {
    if (allcookies[i].split("=")[0].trim() === "access_token") {
      token = allcookies[i].split("=")[1];
    }
  }

  return token;
};

export const setToken = (access_token) => {
  let token = window.sessionStorage.setItem("access_token", access_token);
  window.localStorage.setItem("access_token", access_token);
  window.sessionStorage.removeItem("temp");
  return token;
};

export const setFirebaseToken = (access_token) => {
  let token = window.sessionStorage.setItem("fcm_token", access_token);
  return token;
};

export const setTokenTemp = (access_token) => {
  let token = window.sessionStorage.setItem("access_token", access_token);
  window.sessionStorage.setItem("temp", "1");
  return token;
};

export const isWhitelabel = () => {
  return sessionStorage.getItem("isWhitelabel") === "false" ? false : true;
};

export const getToken = () => {
  let token = window.sessionStorage.getItem("access_token");
  token = token == "null" ? null : token;

  if(!isJwt(token)){
    return false;
  }
  return token;
};


export const getQ2Token = () => {
  let token = window.sessionStorage.getItem("service_provider_token");
  return token;
};

export const setServiceProviderToken = (access_token) => {
  let token = window.sessionStorage.setItem("service_provider_token", access_token);
  return token;
};

export const setEnroll = (enroll) => {
  let token = window.sessionStorage.setItem("enroll", enroll);
  return token;
};

export const getFCMToken = () => {
  let token = window.sessionStorage.getItem("fcm_token");
  return token;
};

export const isLogin = () => {
  let token = window.sessionStorage.getItem("access_token");
  let temp = window.sessionStorage.getItem("temp");

  if(!isJwt(token)){
    return false;
  }

  if (token && !temp) {
    return true;
  }
  return false;
};

export const isJwt=(token)=> {
  if (typeof token !== "string") return false;

  const parts = token.split(".");
  if (parts.length !== 3) return false;

  const base64UrlPattern = /^[A-Za-z0-9_-]+$/;
  if (!parts.every(part => base64UrlPattern.test(part))) return false;

  try {
    const header = JSON.parse(atob(parts[0].replace(/-/g, "+").replace(/_/g, "/")));
    const payload = JSON.parse(atob(parts[1].replace(/-/g, "+").replace(/_/g, "/")));

    return typeof header === "object" && typeof payload === "object";
  } catch {
    return false;
  }
}

export const authToken = () => {
  const token = getToken();
  if (!token) {
    return { 'Idempotency-Key': generateUUID() };
  }
  return {
    "Authorization": `Bearer ${getToken()}`,
    'Idempotency-Key': generateUUID()
  }
};

export const authTokenPwd = (token) => {
  if (!token) {
    return { 'Idempotency-Key': generateUUID() };
  }
  return {
    "Authorization": `PasswordReset ${token}`,
    'Idempotency-Key': generateUUID()
  }
};

export const loginToken = (email, password) => {
  return {
    "Authorization": 'Basic ' + btoa(email + ':' + password),
    'Idempotency-Key': generateUUID()
  }
};

export const loginTokenAuth = (email, password) => {
  sessionStorage.setItem("email", email);
  return btoa(email + ':' + password)
};


